import { Col, Row } from 'react-bootstrap';
import { fadeIn } from '../../Functions/GlobalAnimations';
import { m } from 'framer-motion';
import { useState, useRef } from 'react';
import { getPhotoGallery } from '../../Store/Publication/gallery';

import { useQuery } from '@tanstack/react-query';
import Loading from '../../Components/Loading';
import SliderModal from '../../Components/SliderModal';

// Dummy Data

const PhotoGallery = () => {
	const [selectedGallery, setSelectedGallery] = useState(null);
	const modalTriggerRef = useRef(null);

	const { data: photoData, isLoading } = useQuery({
		queryKey: ['photoGallery'],
		queryFn: () => getPhotoGallery(),
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	});
	const openPhotoModal = galleryItem => {
		setSelectedGallery(galleryItem);
		// Trigger the hidden button click after state is set
		setTimeout(() => {
			if (modalTriggerRef.current) {
				modalTriggerRef.current.click();
			}
		}, 50);
	};

	console.log('photoData>>>>', photoData);

	if (isLoading)
		return (
			<>
				<Loading />
			</>
		);
	return (
		<>
			<m.div className="container mt-[200px] mb-[100px]">
				<Col xl={8} lg={10} className="text-start w-fit">
					<h3 className="font-serif text-[30px] mb-[2px] font-medium text-[#146084]">
						Photo Gallery
					</h3>
					<m.div
						className="border-b border-1 w-[40%] border-[#146084]"
						initial={{ scaleX: 0 }}
						animate={{ scaleX: 1 }}
						transition={{ duration: 0.5, delay: 0.2 }}
					/>
					<p className="text-[16px] text-[#666] mt-4">
						Explore our collection of photos showcasing KERA's activities and
						achievements
					</p>
				</Col>
				<Row className="mt-[100px]">
					{photoData?.data?.map((item, index) => {
						// Get first image as thumbnail
						const thumbnailImage =
							Array.isArray(item?.images) && item?.images?.length > 0
								? item?.images?.[0]?.image
								: [item?.images];

						// Count total images
						const imageCount = item?.images?.length;

						return (
							<Col
								onClick={() => openPhotoModal(item)}
								lg={4}
								md={6}
								sm={12}
								key={item?.id}
								className="mb-[30px] cursor-pointer"
							>
								<m.div
									{...fadeIn}
									transition={{ delay: index * 0.1 }}
									className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300"
								>
									<div className="relative overflow-hidden">
										<img
											src={`https://kera.enfonoerp.com/${thumbnailImage}`}
											alt={item?.title}
											className="w-full h-[250px] object-cover hover:scale-105 transition-transform duration-300"
										/>
										<div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
											<span className="text-white text-[18px] font-medium">
												View Gallery
											</span>
										</div>
										{/* Image count badge */}
										{imageCount > 1 && (
											<div className="absolute top-3 right-3 bg-black bg-opacity-70 text-white px-3 py-1 rounded-full text-[12px] font-medium flex items-center gap-1">
												<svg
													xmlns="http://www.w3.org/2000/svg"
													className="h-3 w-3"
													viewBox="0 0 20 20"
													fill="currentColor"
												>
													<path
														fillRule="evenodd"
														d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
														clipRule="evenodd"
													/>
												</svg>
												{imageCount} Photos
											</div>
										)}
									</div>
									<div className="p-4">
										{item.title && (
											<h4 className="text-[18px] font-medium text-[#146084] mb-2">
												{item?.title}
											</h4>
										)}
										<p className="text-[14px] text-[#666] leading-relaxed line-clamp-3">
											{item?.description}
										</p>
									</div>
								</m.div>
							</Col>
						);
					})}
				</Row>
			</m.div>

			{/* Photo Slider Modal */}
			{selectedGallery && (
				<SliderModal
					photos={selectedGallery.images}
					description={selectedGallery.description}
					title={selectedGallery.title}
					triggerRef={modalTriggerRef}
				/>
			)}
		</>
	);
};

export default PhotoGallery;
